import React from 'react';

export function StatPill({
  children,
  className = '',
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <div
      onClick={onClick}
      className={`h-[90px] flex-1 flex items-center gap-4 px-6 rounded-2xl transition-all duration-200 min-w-0 ${className}`}
    >
      {children}
    </div>
  );
}
